import * as membershipReport from '../services/membershipReport';

export default {
  namespace: 'membershipReport',

  state: {
    userInfo: null,
    memberPageList: null,
    addMember: null,
    levels: [],
    allTotal: 0,
  },

  effects: {
    *queryDirectMarketMemberPage({ payload: { values } }, { call, put }) {
      const response = yield call(
        membershipReport.queryDirectMarketMemberPage,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          memberPageList: response?.data,
        },
      });
    },
    *queryDealerMemberPageNum({ payload: { values } }, { call, put }) {
      const response = yield call(
        membershipReport.queryDirectMarketMemberPage,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          allTotal: response?.data?.total,
        },
      });
    },
    //导出
    *exportDirectMarketMember({ payload: { values }, callback }, { call }) {
      const response = yield call(
        membershipReport.exportDirectMarketMember,
        values,
      );
      callback(response);
    },

    // 获取门店树形列表
    *getStoreTreeList(_, { call, put }) {
      const response = yield call(membershipReport.getStoreTreeList);
      yield put({
        type: 'save',
        payload: {
          storeTreeList: response.data,
        },
      });
    },
    // 获取门店树形列表
    *getStoreAndArea(_, { call, put }) {
      const createId = () => {
        return Math.random().toString(36).substr(2, 10);
      };
      const response = yield call(membershipReport.getStoreAndArea);
      const array = response.data ?? [];
      const newArrayArea = array.map((item) => {
        const id = createId();
        const children = (item.userStoreList ?? []).map((i) => {
          i.parentId = id;
          return { ...i, parentId: item.userSalesArea };
        });
        const areaObj = {
          name: item.userSalesArea,
          id: item.userSalesArea,
          children,
        };
        return areaObj;
      });
      const areasList = array.map((item) => ({
        name: item.userSalesArea,
        id: item.userSalesArea,
      }));
      yield put({
        type: 'save',
        payload: {
          storeAndArea: newArrayArea,
          areasList: areasList,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
